var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.25C27.0532 47.25 30.0766 46.6486 32.8974 45.4802C35.7182 44.3118 38.2813 42.5992 40.4402 40.4402C42.5992 38.2813 44.3118 35.7182 45.4802 32.8974C46.6486 30.0766 47.25 27.0532 47.25 24C47.25 20.9468 46.6486 17.9234 45.4802 15.1026C44.3118 12.2818 42.5992 9.71873 40.4402 7.55977C38.2813 5.4008 35.7182 3.68822 32.8974 2.5198C30.0766 1.35138 27.0532 0.75 24 0.75C17.8337 0.75 11.92 3.19955 7.55977 7.55977C3.19955 11.92 0.75 17.8337 0.75 24C0.75 30.1663 3.19955 36.08 7.55977 40.4402C11.92 44.8004 17.8337 47.25 24 47.25ZM23.4007 33.4033L36.3173 17.9033L32.3493 14.5967L21.241 27.9241L15.4931 22.1736L11.8403 25.8264L19.5903 33.5764L21.5898 35.5759L23.4007 33.4033Z",
    fill: "#34C759"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/true.290db60e6f651cb183d0a2af502c4f65.svg";
export { ForwardRef as ReactComponent };